import React from 'react';
import { Facebook, Instagram, Twitter, Phone, Mail, MapPin } from 'lucide-react';
import Logo from './Logo';
import { DEFAULT_CONTENT, phoneHref } from '../mock';
import { Link } from 'react-router-dom';

const Footer = ({ contact = DEFAULT_CONTENT.contact }) => {
  const areas = contact.areas || [];
  return (
    <footer className="bg-[#0d2417] text-[#c5d6bd]">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-8 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Logo light />
            <p className="mt-4 text-[14px] leading-relaxed text-[#9db593] max-w-[260px]">
              Creating and maintaining beautiful outdoor spaces for homes and businesses across New York City.
            </p>
            <div className="mt-5 flex gap-3">
              {[Facebook, Instagram, Twitter].map((Icon, i) => (
                <a key={i} href="/" onClick={(e) => e.preventDefault()} className="flex h-9 w-9 items-center justify-center rounded-full bg-[#1b4029] text-[#86c93c] hover:bg-[#86c93c] hover:text-[#0d2417] transition-colors" aria-label="Social link">
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display text-white text-lg font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2.5">
              {[['Home','/'],['About Us','/about'],['Services','/services'],['Our Work','/work'],['Reviews','/reviews'],['Contact','/contact']].map(([label,path]) => (<li key={path}><Link to={path} className="text-[14px] hover:text-[#a8d96d] transition-colors">{label}</Link></li>))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-white text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-3 text-[14px]">
              <li><a href={`tel:${phoneHref(contact.phone)}`} className="flex items-center gap-2.5 hover:text-[#86c93c] transition-colors"><Phone className="h-4 w-4 text-[#86c93c]" /> {contact.phone}</a></li>
              <li><a href={`mailto:${contact.email}`} className="flex items-center gap-2.5 hover:text-[#86c93c] transition-colors break-all"><Mail className="h-4 w-4 text-[#86c93c]" /> {contact.email}</a></li>
              <li className="flex items-center gap-2.5"><MapPin className="h-4 w-4 text-[#86c93c]" /> {areas.join(' | ')}</li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-white text-lg font-semibold mb-4">Service Areas</h4>
            <ul className="space-y-2.5 text-[14px]">
              {areas.map((a) => (<li key={a}>{a}, New York</li>))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#1b4029] flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[13px] text-[#7f9a76]">© {new Date().getFullYear()} Ever Leaf NY. All rights reserved.</p>
          <p className="text-[13px] text-[#7f9a76]">Landscaping & Maintenance · New York City</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
